import { Flex, Group, Stack, Text } from '@mantine/core';

import { Content, EditButtonLink } from '@/core/components';

import { Conference } from './model/ConferenceTypes';

interface ConferenceViewProps {
  conference: Conference;
}

export function ConferenceView(props: ConferenceViewProps) {
  const { conference } = props;
  const { conferenceName, confStartDate, confEndDate } = conference;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="10px">
          <Flex justify="space-between">
            <Text fw="500">{conferenceName}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              {/*<ConferenceDeleteButton conferenceId={conference.id} /> TODO ENABLE AFTER SECURITY CHECK*/}
            </Group>
          </Flex>
          <Group>
            <Group>
              <Text
                c="dimmed"
                size="sm"
              >
                {confStartDate ?? '-'} - {confEndDate ?? '-'}
              </Text>
            </Group>
          </Group>
        </Stack>
      </Content>
    </Stack>
  );
}
